import { VisualComponentsContextState } from 'modules/queryBuilder/contexts';
import { EditReadSelect as EditReadVisualComponent } from 'ui/queryBuilder';
import { CustomizedQueryLayout } from './CustomziedQueryLayout';

/**
 * stores custom visual components for cat-in-seg instance of queryBuilder
 */
export const queryBuilderVisualComponents: Partial<VisualComponentsContextState> = {
  EditReadSelect: EditReadVisualComponent,
  QueryLayout: CustomizedQueryLayout,
};
